import React, { useState, memo, useMemo } from 'react';
import trash from 'assets/img/trash.svg';
import styles from './styles.module.scss';

const GiftsFilter = memo(({ brands, onFilter }) => {
    const [selectedBrand, setSelectedBrand] = useState('');

    const handleFilterChange = (event) => {
        const { value } = event.target;
        setSelectedBrand(value);
        onFilter(value);
    };

    const handleClearFilters = () => {
        setSelectedBrand('');
        onFilter('');
    };

    const memoizedBrands = useMemo(() => {
        return brands.map((brand) => (
            <div style={{ display: 'flex', alignItems: 'center' }} key={brand}>
                <span style={{ marginRight: '0.5rem' }}>{brand}</span>
                <div style={{ marginLeft: 'auto' }}>
                    <input
                        type="radio"
                        name="brand"
                        value={brand}
                        checked={selectedBrand === brand}
                        onChange={handleFilterChange}
                        style={{ marginLeft: '0.5rem', transform: 'scale(1.5)' }}
                        className={styles.customradio}
                        id={`radio-${brand}`}
                    />
                    <label htmlFor={`radio-${brand}`} className={styles.radiolabel}></label>
                </div>
            </div>
        ));
    }, [brands, selectedBrand, handleFilterChange]);

    return (
        <div>
            <div className="d-flex justify-content-between">
                <div className={`py-2 ${styles.titleFirst}`}>Filtros</div>
                <div
                    role="button"
                    tabIndex={0}
                    onClick={handleClearFilters}
                    className={`${styles.trash} d-flex align-items-center mb-2`}
                >
                    <img
                        src={trash}
                        className={styles.trashIcon}
                        alt="Limpiar filtros"
                    />
                </div>
            </div>
            <div style={{ flexDirection: 'column' }}>
                <p className={styles.title}>Categorías</p>
                {memoizedBrands}
            </div>
        </div>
    );
});

export default GiftsFilter;
